import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

export const Button = styled.div``;

/** @visibleName Core */
export class ButtonBar extends PureComponent {
  static propTypes = {
    getRef: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    getRef: Function.prototype,
  };

  // Prevent iOS bug which temporarily prevents scrolling content
  preventScroll(event) {
    event.preventDefault();
  }

  render() {
    // Exclude null|undefined values
    const children = React.Children.toArray(this.props.children).filter(
      child => !!child
    );

    return (
      <div
        className={this.props.className}
        onTouchMove={this.preventScroll}
        ref={this.props.getRef}
      >
        {React.Children.map(children, child => (
          <Button children={child} />
        ))}
      </div>
    );
  }
}

export default ButtonBar;
